export default {
  customer: ['customer_management'],
  partner: ['partner_management']
}
